import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function errorMessage(e) {
  const detail = e?.response?.data?.detail;
  if (!detail) return e?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d.msg || JSON.stringify(d)).join(" ");
  return detail.msg || String(detail);
}

export const fileUrl = (path) => (path ? `${API}/files/${path}` : "");
export const pdfUrl = (id) => `${API}/publications/${id}/download`;

export async function pollJob(startPath, body, statusPath = startPath) {
  const { data } = await api.post(startPath, body);
  for (;;) {
    await new Promise((r) => setTimeout(r, 3000));
    const { data: j } = await api.get(`${statusPath}/${data.job_id}`);
    if (j.status === "done") return j.result;
    if (j.status === "error") throw new Error(j.error);
  }
}
